import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import AppShop from './AppShop';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import IndexPage from './components/pages/IndexPage'
import StoriaPage from './components/pages/StoriaPage'
import NotFoundPage from './components/pages/NotFoundPage'
import ContattiPage from './components/pages/ContattiPage'
import Login from './components/MainComponents/Login'
import Logout from './components/MainComponents/Logout'
import Registration from './components/MainComponents/Registration'

import 'bootstrap/dist/css/bootstrap.css';
import * as serviceWorker from './serviceWorker';
import { Redirect, BrowserRouter as Router, Switch, Route} from "react-router-dom";
import HomeShop from './components/shop/HomeShop';
import Shopdetails from './components/shop/Shopdetails';
import NewsLetter from './components/pages/NewsLetter';
import OrderList from './components/shop/OrderList';
import Order from './components/shop/Order';
import CartList from './components/shop/CartList';
import UserProfile from './components/shop/UserProfile';
import AppShopProfile from './components/shop/AppShopProfile';

ReactDOM.render(
    <Router>
    <Switch>
        <Route exact path={"/"} render={(props) => <AppShop><IndexPage></IndexPage></AppShop>} /> 
        <Route exact path={"/newsletter"} render={(props) => <AppShop><NewsLetter {...props}></NewsLetter></AppShop>} /> 
        <Route path={"/storia-del-laboratorio"} render={(v) => <AppShop><StoriaPage></StoriaPage></AppShop>} /> 
        <Route path={"/contatti"} render={(props) => <AppShop><ContattiPage /></AppShop>} />
        <Route path={"/shop/:qualsiasicosa/:id_prodotto"} render={(props) => <AppShop><Shopdetails {...props} /></AppShop>} />
        <Route path={"/shop"} render={(props) => <AppShop><HomeShop /></AppShop>} />
        <Route path={"/cart"} render={(props) => <AppShopProfile><CartList /></AppShopProfile>} />
        <Route path={"/profile"} render={(props) => <AppShopProfile><UserProfile /></AppShopProfile>} />
        <Route path={"/login"} render={(props) => <AppShop><Login /></AppShop>} />
        <Route path={"/register"} render={(props) => <AppShop><Registration /></AppShop>} />
        <Route path={"/logout"} render={(props) => <AppShop><Logout /></AppShop>} />
        <Route path={"/orders"} exact render={(props) => <AppShopProfile><OrderList /></AppShopProfile>}/>
        <Route path={"/orders/:order_id"} render={(props) => <AppShopProfile><Order {...props} /></AppShopProfile>}/>
        {/* <Route path={"/chi-sono"} render={() => <App><ChiSonoPage /></App>} />  */}
        <Route path="/404" render={(props) => <AppShop><NotFoundPage /></AppShop>} />
        <Redirect to="/404" />
    </Switch>
</Router>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
